import React from 'react';
import './Loading.css'; // CSS with background and centering

const Loading = () => {
  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" className="loading-svg">
          <circle fill="#7C2EA0" stroke="#7C2EA0" strokeWidth="15" r="15" cx="40" cy="100">
            <animate 
              attributeName="opacity" 
              calcMode="spline" 
              dur="2" 
              values="1;0;1;" 
              keySplines=".5 0 .5 1;.5 0 .5 1" 
              repeatCount="indefinite" 
              begin="-.4">
            </animate>
          </circle>
          <circle fill="#7C2EA0" stroke="#7C2EA0" strokeWidth="15" r="15" cx="100" cy="100">
            <animate 
              attributeName="opacity" 
              calcMode="spline" 
              dur="2" 
              values="1;0;1;" 
              keySplines=".5 0 .5 1;.5 0 .5 1" 
              repeatCount="indefinite" 
              begin="-.2">
            </animate>
          </circle>
          <circle fill="#7C2EA0" stroke="#7C2EA0" strokeWidth="15" r="15" cx="160" cy="100">
            <animate 
              attributeName="opacity" 
              calcMode="spline" 
              dur="2" 
              values="1;0;1;" 
              keySplines=".5 0 .5 1;.5 0 .5 1" 
              repeatCount="indefinite" 
              begin="0">
            </animate>
          </circle>
        </svg>
        {/* <p className="loading-text">Loading...</p> */}
      </div>
    </div>
  );
};

export default Loading;
